import Vue from 'vue'
import vuetify from './vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify'

Vue.use(VueTelInputVuetify, {
  vuetify,
})
